import { DataService } from "./DataService/DataService";
import { CookieHelper } from "./Helpers/CookieHelper";
import { ElementHelper } from "./Helpers/ElementHelper";
import * as Managers from "./Managers";
import { BlockManager } from "./Managers/BlockManager";

export class App {
    constructor() {
        var widgetBlockStartIndex = 300;
        var bannerBlocks = $("div[data-block-name*='banner'],div[data-block-name*='popup'],div[data-block-name*='hub-header']");
        bannerBlocks.each((index, element) => {
            var block = $(element);

            if(block.data('cache-block') === true) {
                new BlockManager(block).initializeWithoutLoad(undefined);
            }
            else {
                new BlockManager(block).initialize(undefined);
            }
        }).promise().done(() => {
            var blocks : any = $('div[data-block-name]:not([data-block-name*="banner"]):not([data-block-name*="popup"]):not([data-block-name*="hub-header"])');
            blocks.sort(function(a, b) {
                return +a.dataset.index - +b.dataset.index;
            })
    
            blocks.each((index, element) => {
                var block = $(element);

                var zIndex : undefined | number = undefined;
                var blockName = block.data('block-name');
                if(blockName == 'challenge-widget' || blockName == 'update-widget') {
                    zIndex = widgetBlockStartIndex;
                    if(widgetBlockStartIndex > 151) {
                        widgetBlockStartIndex--;
                    }
                }

                if(block.data('cache-block') === true) {
                    new BlockManager(block).initializeWithoutLoad(zIndex);
                }
                else {
                    new BlockManager(block).initialize(zIndex);
                }
            });
        });

        jQuery(window).trigger('resize').trigger('scroll');

        $('#updateList').each((index, element) => {
            new Managers.UpdateListManager($(element)).initialize();
        });

        $('#challengeDetail').each((index, element) => {
            
            new Managers.ChallengeDetailManager($(element)).initialize();
        });

        $('#faq-container').each((index, element) => {
            new Managers.FaqManager($(element)).initialize();
        });
        
        $(".modal").on("click", function (e) {
            const target = $(e.target);
            if (target.hasClass("modal")) {
              $(".modal").removeClass("d-block");
              $(".modal").addClass("d-none");
            }
        });
          
        $(".open-modal").on("click", function (e) {
            $(".modal").removeClass("d-none");
            $(".modal").addClass("d-block");
        });
          
        $(".modal__close").on("click", function () {
            $(".modal").removeClass("d-block");
            $(".modal").addClass("d-none");
        });

        $('.update-header').each((index, element) => {
            ElementHelper.bindListItemsWithHref($(element));
        });

        var body = $('body');

        var mayUserEditPage : boolean = body.data('may-user-edit-page') == 'True';
        if(!mayUserEditPage) {
            var iterations = 0;
            var interval = setInterval(clearQuickEditLinks, 100);
            function clearQuickEditLinks() {
                iterations++;
                $('.block-quick-links').remove();
                if (iterations >= 100) {
                    clearInterval(interval);
                }  
            }
        }

        var isSiteStarthubs : boolean = body.data('is-site-starthubs') == 'True';
        if(!isSiteStarthubs) {
            var cookieName = `gtag-push`;
            var cookie = CookieHelper.getCookie(cookieName);
            if(cookie == undefined || cookie == null || cookie.length == 0) {
                if (typeof (<any>window).gtag != "undefined") {
                    (<any>window).gtag(
                    {
                        'event': 'session_owned_hub'
                    });

                    //(<any>window).gtag('event', 'session_owned_hub');

                    CookieHelper.setCookie(cookieName, "true");
                }
            }
        }
    }
}